export default {
  'rpaAgent.section.agent': 'Logical agent',
  'rpaAgent.section.session': 'Current session',
  'rpaAgent.section.installation': 'Linked device',
  'rpaAgent.section.flows': 'Flows',

  'rpaAgent.field.sessionSequence': 'Sequence',
  'rpaAgent.field.startedAt': 'Link started',
  'rpaAgent.field.endedAt': 'Link ended',
  'rpaAgent.field.endReason': 'End reason',
  'rpaAgent.field.deviceName': 'Device',
  'rpaAgent.field.lastIp': 'Last IP',
  'rpaAgent.field.firstSeenAt': 'First seen',
  'rpaAgent.field.lastSeenAt': 'Last seen',
  'rpaAgent.field.hardwareId': 'Hardware identifier',
  'rpaAgent.field.installationActive': 'Installation active',

  'rpaAgent.empty.unlinked': 'This agent has not been linked to a device yet.',
  'rpaAgent.empty.unlinkedWithHistory':
    'There is no device linked right now. Check history for previous links.',
  'rpaAgent.empty.created':
    'The link was created and is waiting for the device’s first connection.',
  'rpaAgent.empty.flows': 'This agent has no flows yet.',
  'rpaAgent.empty.sessions': 'No sessions to show.',
  'rpaAgent.empty.sessionsMore': 'No more sessions to show.',

  'rpaAgent.action.history': 'Device history',
  'rpaAgent.action.unlink': 'Unlink device',
  'rpaAgent.action.unlink.confirmTitle': 'Unlink device',
  'rpaAgent.action.unlink.confirm':
    'The agent will stop receiving new executions on this device. Executions that already obtained a start lease may finish. History is kept.',
  'rpaAgent.action.deactivate': 'Deactivate',
  'rpaAgent.action.deactivate.confirm': 'The agent will stop accepting new operations. Continue?',
  'rpaAgent.action.rename': 'Rename',
  'rpaAgent.action.copyHardware': 'Copy identifier',
  'rpaAgent.action.copied': 'Identifier copied',
  'rpaAgent.action.loadMore': 'Load more',
  'rpaAgent.action.viewHistory': 'View device history',

  'rpaAgent.sessions.title': 'Device history',
  'rpaAgent.sessions.description': 'Current and past device links for this RPA agent.',
  'rpaAgent.sessions.current': 'Current',
  'rpaAgent.sessions.ended': 'Ended',
  'rpaAgent.sessions.loading': 'Loading history…',
  'rpaAgent.sessions.devicePending': 'Pending device',
  'rpaAgent.sessions.deviceUnknown': 'Unknown device',
  'rpaAgent.sessions.waitingDevice': 'Waiting for the device’s first connection',

  'rpaAgent.summary.flows': '{count, plural, one {# flow} other {# flows}}',
  'rpaAgent.summary.published': '{count} published',
  'rpaAgent.summary.drafts': '{count} drafts',
  'rpaAgent.flow.draft': ' · draft',
  'rpaAgent.summary.todayExecutions': '{count} executions today',
  'rpaAgent.summary.recentErrors': '{count} recent errors',

  'agents.rpa.sessionStatus.created': 'Waiting for connection',
  'agents.rpa.sessionStatus.online': 'Online',
  'agents.rpa.sessionStatus.offline': 'Offline',
  'agents.rpa.sessionStatus.replaced': 'Replaced',
  'agents.rpa.sessionStatus.revoked': 'Revoked',

  'launchpad.actions.add.rpa': 'Add RPA agent',
  'launchpad.kebab.unlinkDevice': 'Unlink device',
  'launchpad.kebab.deviceHistory': 'Device history',
};
